import React from 'react'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Image from '../../../ui/Image'
import LinkHandler from '../../../utils/LinkHandler'
import RichText from '../../../ui/RichText'

const ImageLink = ({
  classNames,
  copy,
  image,
  url,
  styles
}) => (
  <LinkHandler to={url} className={classNames.link}>
    <Image image={image} styles={styles.image} />
    {copy && (
      <RichText styles={styles.copy}>{copy}</RichText>
    )}
  </LinkHandler>
)

export default withStyles(styles)(ImageLink)



// WEBPACK FOOTER //
// ./components/slices/ImageLinks/ImageLink/index.js